// import { spawn } from 'redux-saga/effects'

export default function() {
    return function* rootSaga() {
        // sagas
    }
}



// WEBPACK FOOTER //
// ./src/sagas.js